type Address = {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
};

/**
 * @param address - Address object with optional fields
 * @returns Formatted address string with street on first line and city/state/zip on second line
 */
export const formatAddress = (address: Address): string => {
  const { address1, address2, city, state, postalCode } = address;
  const streetLine = [address1, address2].filter(Boolean).join(', ');
  const cityStateLine = [city, state].filter(Boolean).join(', ');
  const fullCityLine = [cityStateLine, postalCode].filter(Boolean).join(' ');
  return [streetLine, fullCityLine].filter(Boolean).join('\n');
};
